/**
 * Selector: retrieve the collaborative-images slice from the Redux state.
 *
 * @param state – the root Redux state
 * @returns the ICollabImages sub-state (images + isUploading flag)
 */
export const getCollabImagesState = (state) => state['features/collab-images'];
